var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimateActiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,27H31c-1.1030273,0-2-0.8969727-2-2h0.5C37.4951172,25,44,18.4951172,44,10.5C44,5.8129883,40.1870117,2,35.5,2 S27,5.8129883,27,10.5V17c0,1.1030273-0.8969727,2-2,2v-0.5C25,10.5048828,18.4951172,4,10.5,4C5.8129883,4,2,7.8129883,2,12.5 S5.8129883,21,10.5,21H17c1.1030273,0,2,0.8969727,2,2h-0.5C10.5048828,23,4,29.5048828,4,37.5c0,4.6870117,3.8129883,8.5,8.5,8.5 s8.5-3.8129883,8.5-8.5V31c0-1.1030273,0.8969727-2,2-2v0.5C23,37.4951172,29.5048828,44,37.5,44c4.6870117,0,8.5-3.8129883,8.5-8.5 S42.1870117,27,37.5,27z M37.5,42C30.6074219,42,25,36.3925781,25,29.5V29c0-1.1030273-0.8969727-2-2-2 c-2.2055664,0-4,1.7944336-4,4v6.5c0,3.5839844-2.9160156,6.5-6.5,6.5S6,41.0839844,6,37.5C6,30.6074219,11.6074219,25,18.5,25H19 c1.1030273,0,2-0.8969727,2-2c0-2.2055664-1.7944336-4-4-4h-6.5C6.9160156,19,4,16.0839844,4,12.5S6.9160156,6,10.5,6 C17.3925781,6,23,11.6074219,23,18.5V19c0,1.1030273,0.8969727,2,2,2c2.2055664,0,4-1.7944336,4-4v-6.5 C29,6.9160156,31.9160156,4,35.5,4S42,6.9160156,42,10.5C42,17.3925781,36.3925781,23,29.5,23H29c-1.1030273,0-2,0.8969727-2,2 c0,2.2055664,1.7944336,4,4,4h6.5c3.5839844,0,6.5,2.9160156,6.5,6.5S41.0839844,42,37.5,42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateActiveMedium);
export default __webpack_public_path__ + "static/media/climate-active--medium.cff3af93458cc93e417141666b793812.svg";
export { ForwardRef as ReactComponent };